import { z } from "zod";

const notificationStateValue = z.enum(["not-read", "read", "archived", "deleted"]);

export const adminNotificationsListRequestSchema = z.object({
  state: notificationStateValue.optional().nullable(),
  type: z.string().min(1).max(50).optional().nullable(),
  page: z.number().int().min(0).optional().default(0),
  size: z.number().int().min(1).max(200).optional().default(20),
});

export const adminNotificationsStateRequestSchema = z.object({
  notificationIds: z.array(z.string().uuid()),
  state: notificationStateValue,
});

const notificationItemSchema = z.object({
  id: z.coerce.string(),
  title: z.string(),
  content: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  state: z.string(),
  createdAt: z.any().optional().nullable(),
});

export const adminNotificationsListResponseSchema = z.object({
  items: z.array(notificationItemSchema),
  totalCount: z.coerce.number(),
  page: z.coerce.number().int(),
  size: z.coerce.number().int(),
});

export function validateAdminNotificationsListRequest(data) {
  return adminNotificationsListRequestSchema.parse(data ?? {});
}

export function validateAdminNotificationsStateRequest(data) {
  return adminNotificationsStateRequestSchema.parse(data);
}

export function parseAdminNotificationsListResponse(data) {
  return adminNotificationsListResponseSchema.parse(data);
}
 